module.exports = __webpack_public_path__ + "img/pc.e2242305.png";